<ion-app>
  <doka-header
    [environment]="environment.stage !== 'prod' ? environment.stage : undefined"
    rootPath="/my-tasks"
    (onClickLogin)="loginService.login()"
    vcr
  >
    <doka-user-context-menu
      [user]="
        this.loginService.currentUser()
          ? {
              firstname: this.loginService.currentUser().firstname,
              lastname: this.loginService.currentUser().lastname,
              profilePictureUri: this.loginService.currentUser().profilePictureUrl,
              email: this.loginService.currentUser().email,
            }
          : undefined
      "
      [environment]="environment.production ? 'prod' : 'test'"
    >
      @if (userInfoService.isSuperAdmin()) {
        <doka-user-context-menu-entry
          (onAction)="navigateToMasterData()"
          icon="view_list"
          [label]="'UserContext.AdminCatalogManagement' | i18nextEager"
        />
      }
      <doka-user-context-menu-entry
        (onAction)="this.loginService.logout()"
        icon="logout"
        [label]="'UserContext.Logout' | i18nextEager"
      ></doka-user-context-menu-entry>
    </doka-user-context-menu>
  </doka-header>

  <doka-app>
    <div class="flex h-full w-full">
      <app-sidebar [entries]="sidebarEntries"></app-sidebar>

      <doka-content class="flex-1">
        <ion-router-outlet></ion-router-outlet>
      </doka-content>
    </div>
  </doka-app>
  <doka-footer>
    <doka-footer-link href="https://www.doka.com" target="_blank">Doka</doka-footer-link>
    <doka-footer-info>© Doka 2026</doka-footer-info>
  </doka-footer>
</ion-app>
